<script>
import { mapGetters } from 'vuex'

import WidgetPlayerPerformanceGraph from '@widgets/widget-player-performance-graph.vue'
import WidgetPlayerSkillGraph from '@widgets/widget-player-skill-graph.vue'
import WidgetPlayerHeatmapGraph from '@widgets/widget-player-heatmap-graph.vue'
import WidgetSeasonHistory from '@widgets/widget-season-history.vue'
import WidgetPlayerGoalsGraph from '@widgets/widget-player-goals-graph.vue'
import WidgetPerformanceLineup from '@widgets/widget-performance-lineup.vue'
import WidgetStats from '@widgets/widget-stats.vue'
import WidgetCard from '@widgets/widget-card.vue'

export default {
  components: {
    WidgetPlayerPerformanceGraph,
    WidgetPlayerSkillGraph,
    WidgetPlayerHeatmapGraph,
    WidgetSeasonHistory,
    WidgetPlayerGoalsGraph,
    WidgetPerformanceLineup,
    WidgetStats,
    WidgetCard,
  },
  props: {
    player: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      isPlayerDataInitiallyOpen: false,
      toggleIsPlayerDataOpen: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['loggedIn']),
  },
  created() {
    const isPlayerDataOpen = window.localStorage.getItem(
      'wallaPlayerProfileCollapsed'
    )
    if (isPlayerDataOpen === 'true') {
      this.isPlayerDataInitiallyOpen = isPlayerDataOpen === 'true'
    }
  },
  methods: {
    setPlayerDataViewDefault(isPlayerDataCollapsed) {
      window.localStorage.setItem(
        'wallaPlayerProfileCollapsed',
        !isPlayerDataCollapsed
      )
    },
  },
  toggleDetailCardOpen(val) {
    this.toggleIsPlayerDataOpen = !this.toggleIsPlayerDataOpen
  },
}
</script>

<template>
  <WidgetCard
    :class="$style.playerDataMainCollapse"
    :is-initially-open="isPlayerDataInitiallyOpen"
    :is-open-toggle="toggleIsPlayerDataOpen"
    :is-button="true"
    :is-not-collapsible="!loggedIn"
    :show-on-desktop="true"
    :title="$t('expand_player_profile')"
    :title-expanded="$t('collapse_player_profile')"
    :sheet-class="$style.playerDataCollapse"
    @change="setPlayerDataViewDefault"
  >
    <div v-if="loggedIn" :class="$style.layout">
      <v-row>
        <v-col cols="12" lg="5" md="12" sm="12" class="mt-2">
          <WidgetPlayerPerformanceGraph
            :player-id="player.id"
            :sheet-class="$style.upperWidgets"
          />
        </v-col>
        <v-col cols="12" lg="3" md="12" sm="12" class="mt-2">
          <WidgetPerformanceLineup
            :player-id="player.id"
            :sheet-class="$style.upperWidgets"
          />
        </v-col>
        <v-col cols="12" lg="4" md="12" sm="12" class="mt-2">
          <WidgetSeasonHistory
            :player-id="player.id"
            :sheet-class="$style.upperWidgets"
          />
        </v-col>
      </v-row>
      <v-row class=""
        ><v-col lg="3" md="12" sm="12" class="">
          <WidgetPlayerSkillGraph
            :player-id="player.id"
            :sheet-class="$style.lowerWidgets"
          />
        </v-col>
        <v-col lg="4" md="12" sm="12" class="">
          <WidgetStats
            :player-id="player.id"
            :sheet-class="$style.lowerWidgets"
          />
        </v-col>
        <v-col lg="2" md="12" sm="12" :class="$style.doubleRow">
          <WidgetPlayerGoalsGraph
            :player-id="player.id"
            :sheet-class="$style.lowerWidgets"
          />
        </v-col>
        <v-col lg="3" md="12" sm="12" class="">
          <WidgetPlayerHeatmapGraph
            :player-id="player.id"
            :sheet-class="$style.lowerWidgets"
          />
        </v-col>
      </v-row>
    </div>
    <div v-else :class="$style.layout">
      <v-row>
        <v-col cols="12" lg="5" md="12" sm="12" class="mt-2">
          <WidgetPlayerPerformanceGraph
            :player-id="player.id"
            :sheet-class="$style.upperWidgetsNoLogin"
          />
        </v-col>
        <v-col cols="12" lg="3" md="12" sm="12" class="mt-2">
          <WidgetPerformanceLineup
            :player-id="player.id"
            :sheet-class="$style.upperWidgetsNoLogin"
          />
        </v-col>
        <v-col cols="12" lg="4" md="12" sm="12" class="mt-2">
          <WidgetPlayerHeatmapGraph
            :player-id="player.id"
            :sheet-class="$style.upperWidgetsNoLogin"
          />
        </v-col>
      </v-row>
      <v-row class=""
        ><v-col lg="3" md="12" sm="12" class="">
          <WidgetPlayerSkillGraph
            :player-id="player.id"
            :sheet-class="$style.lowerWidgetsNoLogin"
          />
        </v-col>
        <v-col lg="6" md="12" sm="12" class="">
          <WidgetStats
            :show-more-boxes="true"
            :player-id="player.id"
            :sheet-class="$style.lowerWidgetsNoLogin"
          />
        </v-col>
        <v-col lg="3" md="12" sm="12" :class="$style.doubleRow">
          <WidgetPlayerGoalsGraph
            :player-id="player.id"
            :sheet-class="$style.lowerWidgetsNoLogin"
          />
        </v-col>
      </v-row>
    </div>
  </WidgetCard>
</template>

<style lang="scss" module>
@import '@design';

.upperWidgets {
  @media screen and (min-width: $screen-lg) {
    height: 13rem;
  }
}

.lowerWidgets {
  @media screen and (min-width: $screen-lg) {
    height: 22rem;
  }
}

.upperWidgetsNoLogin {
  @media screen and (min-width: $screen-lg) {
    height: 15rem;
  }
}

.lowerWidgetsNoLogin {
  @media screen and (min-width: $screen-lg) {
    height: 20rem;
  }
}

.playerDataMainCollapse {
  margin-top: 1rem;
}

.playerDataCollapse {
  padding: 0;
  background-color: transparent !important;
}
</style>
